import {cs}        from "@Common/react/chain-services";
import {fragments} from "@Common/react/fragments";
import {Invoke}    from "@Common/react/invoke";
import {UseState}  from "@Common/react/use-state";

export const ManualToggle = ({realValue, initUserValue = undefined, onChange, next}) => cs(
    ["userValue", (_, next) => UseState({
        getInitValue: () => initUserValue == null ? null : {value: initUserValue},
        next,
    })],
    ["changing", (_, next) => UseState({next})],
    ({userValue, changing}) => {
        const value = userValue.value ? userValue.value.value : realValue;
        return fragments(
            userValue.value && (!!userValue.value.value === !!realValue) && (
                Invoke({
                    action: () => userValue.onChange(null),
                })
            ),
            next({
                value,
                faking: userValue.value != null,
                reset: () => userValue.onChange(null),
                toggle: async () => {
                    if (changing.value) {
                        return;
                    }
                    const newValue = !value;
                    if (!!newValue === !!realValue) {
                        userValue.onChange(null);
                    } else {
                        const todo = onChange(newValue, !!realValue);
                        if (!todo) {
                            userValue.onChange({value: newValue});
                        } else {
                            userValue.onChange({value: newValue});
                            changing.onChange(true);
                            try {
                                await todo();
                                userValue.onChange(null);
                            } catch (e) {
                                userValue.onChange(userValue.value);
                            } finally {
                                changing.onChange(false);
                            }
                        }
                    }
                    // onChange();
                    // console.log(12312);
                },
            }),
        );
    },
);
